define([
        "dojo/_base/lang",
        "../../../constants/TypeConstants",
        "../properties/TypeProperty",
        "../properties/TagProperty",
        "../properties/EnabledProperty",
        "../properties/GalleryItemRowCountProperty",
        "../properties/GalleryItemTextLineCountProperty",
        "../properties/GalleryItemWidthProperty",
        "../properties/ScrollToSelectionProperty",
        "../properties/HideDisabledItemsProperty",
        "../properties/MnemonicProperty",
        "../properties/OpenIfEmptyProperty",
        "../properties/QabEligibleProperty",
        "../properties/OwnsPopupProperty"
    ],
    function (lang, TypeConstants, TypeProperty, TagProperty, EnabledProperty, GalleryItemRowCountProperty,
              GalleryItemTextLineCountProperty, GalleryItemWidthProperty, ScrollToSelectionProperty,
              HideDisabledItemsProperty, MnemonicProperty, OpenIfEmptyProperty, QabEligibleProperty,
              OwnsPopupProperty) {
        var hash = {};

        hash[TypeConstants.GALLERY] = lang.mixin({}, {
            galleryPopupId: {
                type: "string",
                notInAction: true,
                required: true
            },
            minColumnCount: {
                type: "number",
                notInAction: true,
                required: false,
                defaultValue: 3
            },
            maxColumnCount: {
                type: "number",
                notInAction: true,
                defaultValue: 7
            },
            currentColumnCount: {
                type: "number",
                notInAction: true,
                required: false,
                defaultValue: 7
            },
            textOverlay: {
                type: "string",
                notInAction: true,
                required: false,
                defaultValue: ""
            },
            displayState: {
                type: "string",
                notInAction: true,
                required: false,
                defaultValue: "normal"
            },
            shouldRefresh: {
                type: "boolean",
                notInAction: true,
                defaultValue: true,
                required: false
            }
        }, EnabledProperty, TypeProperty, TagProperty, GalleryItemRowCountProperty, GalleryItemTextLineCountProperty, 
            GalleryItemWidthProperty, ScrollToSelectionProperty, HideDisabledItemsProperty, 
            MnemonicProperty, OpenIfEmptyProperty, QabEligibleProperty, OwnsPopupProperty);

        return hash;
    });

